module.exports = __webpack_public_path__ + "img/GAME_POND1.867d92aa.jpg";